import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const NAMES = [
  { name: "Jessica M.", location: "Orlando, FL" },
  { name: "Marie & David L.", location: "Winter Park, FL" },
  { name: "Fabienne D.", location: "Kissimmee, FL" },
  { name: "Ashley R.", location: "Atlanta, GA", virtual: true },
  { name: "Karen S.", location: "Sanford, FL" },
  { name: "Renee & Marcus T.", location: "Tampa, FL", virtual: true },
];

export default function Testimonials() {
  const { t } = useT();
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-[#AE8F78] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="mb-14 sm:mb-20 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.25em] text-[#F8F7F3]/85 font-semibold mb-4">
            {t("test.eyebrow")}
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl font-light leading-[1.05] text-[#F8F7F3]">
            {t("test.title.a")}{" "}
            <em className="text-[#3F5043]">{t("test.title.em")}</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {NAMES.map((p, i) => (
            <motion.div
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="rounded-3xl bg-[#F8F7F3] p-8 sm:p-10 flex flex-col"
            >
              <Quote
                size={28}
                strokeWidth={1.2}
                className="text-[#875F45] mb-5 opacity-70"
              />
              <p className="font-serif text-lg sm:text-xl leading-snug text-[#3F5043] flex-1">
                “{t(`test.${i + 1}.text`)}”
              </p>
              <div className="mt-7 pt-5 border-t border-[#BCB3A6]/40">
                <div className="text-sm font-semibold text-[#3F5043]">
                  {p.name}
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-[#899480] mt-1">
                  {p.virtual ? `${t("test.virtual")} · ${p.location}` : p.location}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
